import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';

const EnrollComplete = observer(class EnrollComplete extends React.Component {
  componentDidUpdate() {
    const main = document.getElementById('complete-main');
    if (main && this.props.isActive === 'slide-active') {
      setTimeout(()=>main.focus(),250)
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <div className={`panel panel--brief ${this.props.isActive}`}>
        <h1 className="panel__title" id="complete-main" tabIndex="0">{translation.heading}</h1>

        <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.body)}}></div>

        <Link className="btn btn--icn-right next" to={this.props.store.SessionStore.afterEnroll}>
          {translation.button}
          <icons.iconCircleRight />
        </Link>
      </div>
    );
  }
})

export default translate('EnrollComplete')(EnrollComplete);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollComplete.js